import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface IBadgeTemplate {
    id?: string
    code: string
    category: string
    type: string
    name_i18n: {[key: string]: string}
    description_i18n: {[key: string]: string}
    criteria_i18n: {[key: string]: string}
    requirement_i18n: {[key: string]: string}
    image: string
    image_mini: string
    image_disabled: string
    grant_type: string
    auto_rule?: string
    is_active: boolean
    sort_order: number
    remark?: string
    created_at?: number
    updated_at?: number
}

export const BADGE_CATEGORIES = ['asset', 'volume', 'league', 'tradermap', 'copy_leader', 'copy_trader', 'event'] as const
export const BADGE_TYPES = ['limited', 'permanent'] as const
export const BADGE_GRANT_TYPES = ['manual', 'auto', 'both'] as const

export const getBadge = async (id: string): Promise<ApiRes<IBadgeTemplate>> => {
    return await apiGet(API_URL, `admin/badges/${id}`)
}
